export enum AvlDeviceType {
  Ruptela = 'RUPTELA',
  TeltonikaFMC640 = 'TELTONIKA-FMC640',
  FMC130 = 'FMC130'
}
